import React from 'react';

interface MetricCacheContextType {
  normalMetricsCache: Map<string, Metrics.NormalMetric>;
  compoundMetricsCache: Map<string, Metrics.CompoundMetric>;
  requestMetricsByIds: (ids: string[]) => void;
  requestAllNormalMetrics: () => void;
  requestAllCompoundMetrics: () => void;
  allMetricsLoaded: boolean;
  isIdResolved: (id: string) => boolean;
  isIdErrored: (id: string) => boolean;
}

const MetricCacheContext = React.createContext<MetricCacheContextType>({
  normalMetricsCache: new Map(),
  compoundMetricsCache: new Map(),
  requestMetricsByIds: () => undefined,
  requestAllNormalMetrics: () => undefined,
  requestAllCompoundMetrics: () => undefined,
  allMetricsLoaded: false,
  isIdResolved: () => false,
  isIdErrored: () => false,
});

export default MetricCacheContext;
